import { Component, Input, NgZone, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';


@Component({
  selector: 'app-articulos',
  templateUrl: './articulos.component.html',
  styleUrls: ['./articulos.component.css']
})

export class ArticulosComponent {


  constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

      this.toastr.setRootViewContainerRef(vcr);
      this.descargarArticulos();
      this.orden(2);

    };


    uploaded = {
      Status:0,
      Text:''

    }

    @Input() articulos: any = [];

    articuloSearch: string ='';
    place:string = 'Buscar por Articulo';
    sort: string = 'nombre';
 
    orden(n) {
      if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
      if (n == 2) { this.sort='nombre'; this.place='Buscar por Articulo' };
      if (n == 3) { this.sort='preciocompra'; this.place='Buscar por Precio Compra' };
      if (n == 4) { this.sort='precioventa'; this.place='Buscar por Precio Venta' };
      if (n == 5) { this.sort='iva'; this.place='Buscar por IVA' };
    }

   quitarfiltro(tipo: Number) {
      this.articuloSearch = '';
   }

  filtro() {

      return this.articulos.filter((articulo) => {
         if (this.sort == 'nombre')
            return articulo.nombre.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) != -1;
         if (this.sort == 'Id')
           return articulo.Id.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) != -1;
         if (this.sort == 'preciocompra')
           return articulo.preciocompra.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) != -1;
         if (this.sort == 'precioventa')
           return articulo.precioventa.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) != -1;
         if (this.sort == 'iva')
           return articulo.iva.toLowerCase().indexOf(this.articuloSearch.toLowerCase()) != -1;

       });
  }


  descargarArticulos() {
          this.http.loading = true;
          this.http.descargarArticulos()
                  .subscribe(articulo => {
                       this.articulos = articulo;
                       this.http.loading = false;

                  }, err => {
                     (err.message);
                  }, () => {
                     ('completed');

           });
        }



  pulsado(articulo) {
      this.http.articuloGrabar = articulo;

      this.http.sw.mostrarArticulos = false;
      this.http.sw.mostrarMenu = false;
      this.http.sw.mostrarDatosarticulos = true;
  }

  crearArticulo() {

     this.http.articuloGrabar = this.http.nuevoArticulo();
     this.http.sw.mostrarDatosarticulos = true;
  }



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/articulos/articulos.component.ts